import { Link } from '@tanstack/react-router';

/** Logo + name; links home */
export function BrandMark() {
  return (
    <Link
      to="/"
      className="flex items-center gap-2 rounded-md outline-none focus-visible:ring-3 focus-visible:ring-ring/50"
    >
      <span
        aria-hidden
        className="flex size-7 items-center justify-center rounded-[9px] bg-primary text-[13px] font-bold text-primary-foreground"
      >
        B
      </span>
      <span className="text-[17px] font-semibold tracking-tight">Budgie</span>
    </Link>
  );
}
